export default __webpack_public_path__ + "static/media/Z_Zumbi.c6de309d.mp3";